'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  flex-direction: row;\n  flex: 1;\n  background-color: ', ';\n  min-height: 6px;\n  max-height: 6px;\n  border-radius: 3px;\n'], ['\n  flex-direction: row;\n  flex: 1;\n  background-color: ', ';\n  min-height: 6px;\n  max-height: 6px;\n  border-radius: 3px;\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var strengthLevelColors = {
  0: '#ededed',
  1: '#ff4444',
  2: '#ee9e1a',
  3: '#75c232',
  4: '#008348'
};
var strengthRectangle = (0, _styledComponents2.default)(_View2.default)(_templateObject, function (props) {
  return strengthLevelColors[props.level || 0];
});
strengthRectangle.defaultProps = {
  level: 0
};
exports.default = strengthRectangle;